import { IEmailNamePair } from './email-name-pair.interface'
import { CheckoutType, PaymentFeature } from './payment'
import { IUser } from './user'

export enum EnquiryFeature {
  PaymentMethod = 'PAYMENT-METHOD',
  PaymentFeature = 'PAYMENT-FEATURE',
  FutureCohorts = 'FUTURE-COHORTS',
  CohortPrice = 'COHORT-PRICE',
  CourseRequest = 'COURSE-REQUEST',
}

export enum EnquiryStatus {
  Created = 'CREATED',
  Pending = 'PENDING',
  AwaitingResponse = 'AWAITING_RESPONSE',
  Resolved = 'RESOLVED',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
}

export const FinalEnquiryStatuses = [
  EnquiryStatus.Resolved,
  EnquiryStatus.Cancelled,
  EnquiryStatus.Failed,
]

export enum EnquiryAction {
  EnquiryAssigned = 'ENQUIRY-ASSIGNED',
  InvitationEmailSent = 'INVITATION-EMAIL-SENT',
  ResolutionEmailSent = 'RESOLUTION-EMAIL-SENT',
}

type TargetEntity = {
  name: string
  id: string
}

export interface PaymentMethodContext {
  course: string
  cohort: string
  educationProvider: string
  company: string | null
  paymentMethod: CheckoutType
  invitee: Required<IEmailNamePair>
}

export interface CohortPriceContext {
  course: string
  cohort: string
  educationProvider: string
}

export interface FutureCohortsContext {
  course: string
  educationProvider: string
}

export interface PaymentFeatureContext {
  paymentFeature: PaymentFeature
  company: string | null
  course: string
  invitee?: Required<IEmailNamePair>
}

export interface CourseRequestContext {
  customer: string
  chatSession?: string
  subject: string
}

export type EnquiryContext =
  | PaymentMethodContext
  | CohortPriceContext
  | FutureCohortsContext
  | PaymentFeatureContext
  | CourseRequestContext

export interface IEnquiryHistoryEntry {
  targetEntity: TargetEntity
  user: string
  action: EnquiryAction
  message?: string
  context?: Record<string, unknown>
}

export interface IEnquiryHistoryEntryPayload
  extends Omit<IEnquiryHistoryEntry, 'createdAt' | 'user'> {
  createdAt: string
  user: string
}

export interface IEnquiryHistoryEntryCreatePayload
  extends Omit<IEnquiryHistoryEntryPayload, 'createdAt'> {}

export interface IEnquiry {
  _id: string
  featureRequest: EnquiryFeature
  context?: EnquiryContext
  status: EnquiryStatus
  assignee: string | IUser | null
  reporter: string | IUser
  history: IEnquiryHistoryEntry[]
}

export interface IEnquiryCreatePayload
  extends Pick<IEnquiry, 'featureRequest' | 'context'> {
  status?: EnquiryStatus
  assignee?: string | null
  reporter?: string
}

export interface IEnquiryFullUpdatePayload
  extends Omit<
    IEnquiry,
    '_id' | 'createdAt' | 'updatedAt' | 'assignee' | 'reporter'
  > {
  assignee: string | null
  reporter: string
}

export interface IEnquiryPartialUpdatePayload
  extends Partial<IEnquiryCreatePayload> {}
